import { IAuditLogPayload } from "../../../types/audit";

const STORAGE_KEY = "pending_audit_logs";

export const savePendingEntries = (entries: IAuditLogPayload[]): void => {
  try {
    const existing: IAuditLogPayload[] = JSON.parse(
      localStorage.getItem(STORAGE_KEY) || "[]"
    );
    const merged = [...existing, ...entries];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
    console.log(
      `[audit] saved ${entries.length} pending entries (total: ${merged.length})`
    );
  } catch (err) {
    console.error("[audit] failed to save pending entries to localStorage", err);
  }
};

export const removeFirstEntry = (): void => {
  try {
    const existing: IAuditLogPayload[] = JSON.parse(
      localStorage.getItem(STORAGE_KEY) || "[]"
    );
    const removed = existing.shift();
    if (existing.length === 0) {
      localStorage.removeItem(STORAGE_KEY);
    } else {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
    }
    console.log(
      `[audit] removed first pending entry (${existing.length} remaining)`,
      removed?.service_type,
      removed?.action
    );
  } catch (err) {
    console.error("[audit] failed to remove first pending entry", err);
    localStorage.removeItem(STORAGE_KEY);
  }
};

export const getPendingEntries = (): IAuditLogPayload[] => {
  try {
    const entries: IAuditLogPayload[] = JSON.parse(
      localStorage.getItem(STORAGE_KEY) || "[]"
    );
    if (entries.length > 0) {
      console.log(`[audit] found ${entries.length} pending entries in localStorage`);
    }
    return entries;
  } catch (err) {
    console.error("[audit] failed to read pending entries from localStorage", err);
    return [];
  }
};
